import { SET_ALL_TASK, ADD_TASK, UPDATE_TASK, DELETE_TASK } from "./taskAction";
// import { UPDATE_TASK_FIELDS } from './taskActionTypes';
// או מהנתיב שבו הגדרתן את הקבוע
import { SET_SELECTED_TASK } from './taskAction';

const initialState = {
  allTask: [],
  selectedTask: null,
};

const taskReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_TASK:
      return {
        ...state,
        allTask: action.payload,
      };

    case SET_SELECTED_TASK:
      return {
        ...state,
        selectedTask: action.payload,
      };
    case ADD_TASK:
      return {
        ...state,
        allTask: [...state.allTask, action.payload],
      };

    case UPDATE_TASK:
      return {
        ...state,
        allTask: state.allTask.map((t) =>
          t.id === action.payload.id ? action.payload : t
        ),
      };
    case DELETE_TASK:
      return {
        ...state,
        allTask: state.allTask.filter(task => task.taskId !== action.payload),
      };

    default:
      return state;
  }
};

export default taskReducer;
